import { useState } from "react";
import { IOrder } from "../../interfaces/IOrder";
import OrderStatus from "./OrderStatus";
import ProdType from "../products/ProdType";

const OrderListItem = (props: { order: IOrder }) => {
    const [showProd, setShowProd] = useState(false);

    return (
        <>
            <div className="list-item">
                <div className="list-item-content">
                    <div className="list-item-title">
                        Zamówienie nr: <span className="has-text-weight-semibold">{props.order.orderId}</span> z dnia {props.order.date}
                    </div>
                    <div className="list-item-description">
                        <div>
                            status: <OrderStatus status={props.order.status} paymentSys={props.order.paymentSys} />
                        </div>
                        <div>wartość zamówienia: {props.order.summary} zł</div>
                        {/* <div>
                            <a
                                className="is-size-7"
                                onClick={() => {
                                    setShowProd(!showProd);
                                }}
                            >
                                {showProd ? <>ukryj listę produktów</> : <>pokaż listę produktów</>}
                            </a>
                        </div> */}
                        <div className={showProd ? "" : "is-hidden"}>
                            <div className="list ">
                                {props.order.products?.map((cartProduct, key) => (
                                    <div className="list-item" key={key}>
                                        <div className="list-item-content">
                                            <div className="list-item-title">
                                                {key + 1}. {cartProduct.product?.pName}
                                            </div>
                                            <div className="list-item-description">
                                                <nav className="level">
                                                    <div className="level-left">
                                                        <div className="level-item">
                                                            <ProdType
                                                                className="is-inline has-text-weight-semibold"
                                                                prodType={cartProduct.product?.prodType}
                                                                courseType={cartProduct.product?.courseType}
                                                            />
                                                        </div>
                                                        <div className="level-item">wartość: {cartProduct.product?.price} zł</div>
                                                        <div className="level-item">ilość: {cartProduct.cnt}</div>
                                                    </div>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="list-item-controls">
                    <div className="buttons is-right">
                        <button
                            className="button"
                            onClick={() => {
                                setShowProd(!showProd);
                            }}
                        >
                            <span className="icon is-small">
                                <i className="fas fa-ellipsis-h"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderListItem;
